import _ from "lodash";
import { buildValidationParameters, buildGlobalValidationParameters } from "../utils/validator_rules";
import SimpleReactValidator from 'simple-react-validator';

export const validator = new SimpleReactValidator({});

const areGlobalStencilParametersValid = (stencilsParameters) => {
  const parameters = stencilsParameters || {};
  const validationParameters = buildGlobalValidationParameters(parameters);
  return Object.keys(validationParameters)
          .map((key) => validator.check(validationParameters[key].value, validationParameters[key].rule))
          .reduce((acc, curr) => acc && curr, true);
}

const isStencilAvailableForCart = (stencil, stencilsType) => {
  const parameters = stencil.parameters || {};
  const validationParameters = buildValidationParameters(stencilsType, parameters);
  return Object.keys(validationParameters)
          .map((key) => validator.check(validationParameters[key].value, validationParameters[key].rule))
          .reduce((acc, curr) => acc && curr, true);
}

export const updateStencilsForOrder = (state) => {
  if(areGlobalStencilParametersValid(state.stencilsParameters) && 
      state.stencils.filter((s) => !isStencilAvailableForCart(s, state.stencilsType)).length === 0) 
    state.stencilsToBuy = _.cloneDeep(state.stencils)
}